import StackLayoutProvider from './hooks/useStackLayout';

import { StackLayoutProps } from './@types/StackLayoutProps';
import { ReactNode } from 'react';
import { useCssHandles } from '../../../utils/functions';

const CSS_HANDLES = ['stackContainer', 'stackItem'];
const StackLayout = (props: StackLayoutProps) => {
	const { handles }: any = useCssHandles('vtex-stack-layout-0-x', CSS_HANDLES, props.blockClass);
	return (
		<StackLayoutProvider {...props}>
			<div data-selection={props.componentId} className={`${handles.stackContainer} relative`}>
				{props?.children?.map((child: ReactNode, index: number) => (
					<div
						key={`${props.blockClass}--${index}`}
						className={`stackItem stackItem--${props.blockClass} ${index == 0 ? `stackItem--first stackItem--${props.blockClass}--first vtex-stack-layout-0-x-stackItem--first vtex-stack-layout-0-x-stackItem--${props.blockClass}--first` : ''} vtex-stack-layout-0-x-stackItem vtex-stack-layout-0-x-stackItem--${props.blockClass} ${index !== 0 ? `absolute top-0 left-0 w-auto h-auto` : ``}`}
						style={{ zIndex: 1 }}
					>
						{child}
					</div>
				))}
			</div>
		</StackLayoutProvider>
	);
};

export default StackLayout;
